// extracted by mini-css-extract-plugin
export default {"reviewItem":"reviewItem-lFDiL","location":"location-au5dY","base":"base-JdklJ","image":"image-czc8h","reviews":"reviews-_f9aI"};